module.exports = __webpack_public_path__ + "static/media/iStock-485196183.af3e7ddf.jpg";